import React from 'react'

const TopBorder = ({value}) => {
  return (
    <div className='text-center py-5 ad-bg-cyan'>
      <h2>{value}</h2>
      <span></span>
    </div>
  )
}

export default TopBorder
